import React from 'react'
import { Cell } from '../../styles/styled-common'
import CheckListCell from './CheckListCell'

// insert if
const a = []
const ii = (condition, ...elements) => (condition ? elements : a)

export default class ModsCell extends React.PureComponent {
  render() {
    const { mods, ...props } = this.props

    if (!mods) return <Cell {...props} />

    const list = [
      ...ii(mods.supported, 'All Mods Supported'),
      ...ii(mods.autoUpdate, 'Auto Updating Mods'),
      ...ii(mods.oneclick, '1-Click Install & Update'),
      ...ii(mods.modManager, 'Mod Manager GUI'),
    ]

    return (
      <Cell {...props}>
        <CheckListCell list={list} />
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/ModsCell.jsx